import fb from '@/firebaseConfig';
import { isToday } from '@/helpers/timeHelpers';
import analytics from '@/utils/Analytics';

// TODO Get new subscriber set when user subscribes
// TODO Handle remote config posts

/*

  STATE

 */

const state = {
  post: null,
  postSet: [], // Ex: [{ id, type, content, tagName, color }]
  postIndex: 0,
  indexUpdatedAt: null,
  postsLoaded: false,
};

/*

  GETTERS

 */

const getters = {
  // Add any conditions that impact visibility of daily post
  showPost: (state, getters, rootState) => {
    const { welcomeSlideNum } = rootState.user;
    return welcomeSlideNum < 1;
  },
};

/*

  ACTIONS

 */

const actions = {
  // Prioritizing getting current post as quickly as possible
  // If posts already loaded, do nothing
  // If already updated today, or post not needed ==> fetch today's post  & set existing post data
  // If post not updated yet today:
  //    ==> Set today's post & fetch
  //    If user doesn't have set ==> get new user set
  //    If at the end of set, or current post doesn't have content ==> get new set
  //    If not at the end ==> update index

  init({ commit, dispatch, state }, { posts, welcomeSlideNum }) {
    if (state.postsLoaded) return;
    // console.log('Posts init');

    const { postSet = [] } = posts || {};
    let { postIndex = 0, indexUpdatedAt = null } = posts || {};
    const showPost = welcomeSlideNum < 1; // Update with other conditions

    if (showPost && !isToday(indexUpdatedAt ? indexUpdatedAt.toDate() : null)) {
      postIndex += 1;
      indexUpdatedAt = fb.currentTimestamp();
      const todaysPost = postSet[postIndex] || {};
      if (todaysPost.content) {
        commit('setPosts', { postSet, postIndex, indexUpdatedAt });
      }

      if (!postSet.length) {
        dispatch('updatePostSetInDB', { indexUpdatedAt, isNewUser: true });
      } else if (postIndex === postSet.length - 1 || !todaysPost.content) {
        dispatch('updatePostSetInDB', { indexUpdatedAt });
      } else {
        dispatch('updateIndexInDB', { postIndex, indexUpdatedAt });
      }
    } else {
      commit('setPosts', { postSet, postIndex, indexUpdatedAt });
      dispatch('user/saveUserInitDataToDB', { moduleName: 'posts' }, { root: true });
    }
  },

  updateIndexInDB({ dispatch }, { postIndex, indexUpdatedAt }) {
    dispatch(
      'user/saveUserInitDataToDB',
      {
        moduleName: 'posts',
        moduleData: {
          'posts.postIndex': postIndex,
          'posts.indexUpdatedAt': indexUpdatedAt,
        },
      },
      { root: true }
    );
  },

  async updatePostSetInDB(
    { dispatch, rootState },
    { indexUpdatedAt, isNewUser = false, isNewMember = false }
  ) {
    const { uid } = rootState.user;
    try {
      const getNewPostSet = fb.functions.httpsCallable('post-getNewPostSet');
      const { data: newSet } = await getNewPostSet({ uid, isNewUser, isNewMember });
      dispatch(
        'user/saveUserInitDataToDB',
        {
          moduleName: 'posts',
          moduleData: {
            'posts.postSet': newSet,
            'posts.postIndex': 0,
            'posts.indexUpdatedAt': indexUpdatedAt,
          },
        },
        { root: true }
      );
    } catch (error) {
      console.error('Error generating new posts', error);
      analytics.exception('Error generating new posts');
    }
  },
};

/*

  MUTATIONS

 */

const mutations = {
  setPosts(state, data) {
    const { postSet = [], postIndex = 0, indexUpdatedAt } = data;
    state.post = postSet[postIndex] || null;
    state.postSet = postSet;
    state.postIndex = postIndex;
    state.indexUpdatedAt = indexUpdatedAt ? indexUpdatedAt.toDate() : null;
    state.postsLoaded = postSet && postSet.length;
  },

  setIndex(state, { postIndex, indexUpdatedAt }) {
    state.postIndex = postIndex;
    state.indexUpdatedAt = indexUpdatedAt;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
